import React from "react"
import { resourceTabList } from "./sc-analyzer-frontend-data"
import { graphIcon } from "src/components/icons-svg"
import Tooltip from "src/components/tooltip"

/**
 * @param props {{
 * scState:scState
 * }}
 */
export default function LeftSideTabs({ scState }) {
  return (
    <div
      css={`
        padding-top: 25px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      `}
    >
      {!scState.selectedResourseType && <div>Choose a resource type:</div>}
      <div
        css={`
          display: flex;
          margin-top: 10px;
        `}
      >
        {scState.json.tabsArray.map((tab) => {
          var isSelected = tab.id == scState.selectedResourseType
          let progressForTab = scState.getProgressForTab(tab.id)

          return (
            <div
              onClick={() => scState.set_selectedResourseType(tab.id)}
              css={`
                font-size: 16px;
                font-weight: ${isSelected ? 600 : 400};
                margin-right: 9px;
                white-space: nowrap;
                background-color: ${isSelected ? "#ffceb4" : "white"};
                cursor: ${isSelected ? "default" : "pointer"};
              `}
              key={tab.id}
            >
              <div
                css={`
                  padding: 10px 8px;
                `}
              >
                {tab.name}
              </div>
              <div
                css={`
                  width: ${Math.floor(
                    // @ts-ignore
                    progressForTab.total === 0
                      ? 0
                      : (progressForTab.completed / progressForTab.total) * 100,
                  )}%;
                  height: 5px;
                  background-color: #1a90ff;
                `}
              ></div>
            </div>
          )
        })}
      </div>      
    </div>
  )
}
